<template>
  <div class="col">
    <div class="row align-items-baseline">
      <div class="col-10">
        <ArtistDetails
          v-if="artwork.artist"
          class="headings--h2 artwork__header"
          :artist="artwork.artist"
        />
        <div
          v-else
          class="headings--h2 artwork__header"
        >
          {{ artwork.name }}
        </div>
      </div>
      <div class="col-2 text-right">
        <ArtworkMemorise
          :artwork="artwork"
          :modal="true"
          @handleMemoriseResponse="changeArtworkMemoriseState"
        />
      </div>
    </div>
    <div class="details__art-desc">
      <h4 v-if="artwork.artist"> {{ artwork.name }} </h4>
    </div>
    <p v-html="artwork.description"></p>
    <div v-if="haveSaleDetailsProvided" class="artwork__table-data">
      <ArtworkState :artwork="artwork" />
        <div>
          <span class="title d-block">{{ I18n.t("artworks.starting_price_label") }}</span>
          <span v-if="artwork.startingPrice > 0" class="price">
           {{ I18n.t("price_with_currency", { price: formatPrice(artwork.startingPrice) }) }}
         </span>
         <span v-else>
           <span class="price--info" v-b-tooltip.hover.rightbottom :title="I18n.t('artworks.no_starting_price_info')"></span>
         </span>
       </div>
       <div>
        <span v-if="artwork.estimationMin && artwork.estimationMax">
          <span class="title d-block"> {{ I18n.t("artworks.estimation_label") }} </span>
          <span class="price artwork__estimation">
            {{ I18n.t("artworks.estimated_prices_with_currency",
            { price_min: formatPrice(artwork.estimationMin),
              price_max: formatPrice(artwork.estimationMax) }) }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import ArtworkMemorise from '@/shared/components/artwork_memorise';
  import ArtworkState from './artwork_state';
  import ArtistDetails from './../artist_details';
  import { formatNumber } from './../../helpers';

  export default {
    name: 'ArtworkContent',
    components: {
      ArtistDetails,
      ArtworkState,
      ArtworkMemorise,
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    methods: {
      ...mapMutations(['SET_MEMORISE_STATE']),
      changeArtworkMemoriseState(artworkId) {
        this.SET_MEMORISE_STATE(artworkId);
      },
    },
    computed: {
      haveSaleDetailsProvided() {
        return Object.prototype.hasOwnProperty.call(this.artwork, 'startingPrice') ||
          Object.prototype.hasOwnProperty.call(this.artwork, 'estimationMin') ||
          Object.prototype.hasOwnProperty.call(this.artwork, 'estimationMax');
      },
    },
    created() {
      this.formatPrice = formatNumber;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/modal/artwork_content.vue?6b86db99